import * as actionTypes from './types';

const INITIAL_STATE = {
  current: {},
  isLoggedIn: false,
  isLoading: false,
  isSuccess: false,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
      };

    case actionTypes.REQUEST_SUCCESS:
      return {
        current: action.payload,
        isLoading: false,
        isLoggedIn: true,
        isSuccess: true,
      };

    // Patch only the specified fields on current — keeps isLoggedIn/isLoading intact.
    // Used for photo uploads and other partial profile updates that don't require
    // a full re-login.
    case actionTypes.UPDATE_CURRENT:
      return {
        ...state,
        current: {
          ...state.current,
          ...action.payload,
        },
      };

    case actionTypes.LOGOUT_SUCCESS:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default authReducer;
